import { themeGetColor } from '@pocketlaw/tetris';
export const RECHARTS_FONT_SIZE = 12;
export const TOOLTIP_CURSOR_FILL = themeGetColor('background.100');
export const MIN_RECHART_HEIGHT = 200;
